export default function ProfileActionsModal({
  open,
  onClose,
  onSupport,
  onRestart,
  onExit,
  onDelete,
  deleting = false,
}: {
  open: boolean
  onClose: () => void
  onSupport: () => void
  onRestart: () => void
  onExit: () => void
  onDelete: () => void
  deleting?: boolean
}) {
  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/65 p-4 sm:items-center"
      role="dialog"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-sm rounded-2xl border border-white/10 bg-[#14141f] p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="absolute right-3 top-3 text-white/70"
          onClick={onClose}
          disabled={deleting}
        >
          ✕
        </button>
        <h2 className="text-lg font-extrabold text-white">Действия с профилем</h2>
        <p className="mt-1 text-xs text-white/45">
          Сброс прогресса, выход из игры или удаление паспорта
        </p>

        <div className="mt-4 flex flex-col gap-2">
          <ActionRow
            title="Написать в поддержку"
            sub="До 5 обращений в сутки"
            onClick={() => {
              onClose()
              onSupport()
            }}
            disabled={deleting}
          />
          <ActionRow
            title="Начать заново"
            sub="Новые стартовые карты, прогресс сбросится"
            onClick={() => {
              onClose()
              onRestart()
            }}
            disabled={deleting}
            destructive
          />
          <ActionRow
            title="Выйти из игры"
            sub="Вернуться на экран входа"
            onClick={() => {
              onClose()
              onExit()
            }}
            disabled={deleting}
          />
          <ActionRow
            title={deleting ? "Удаление…" : "Удалить игровой профиль"}
            sub="Паспорт и карты будут удалены"
            onClick={() => {
              onClose()
              onDelete()
            }}
            disabled={deleting}
            destructive
          />
        </div>
      </div>
    </div>
  )
}

function ActionRow({
  title,
  sub,
  onClick,
  disabled,
  destructive,
}: {
  title: string
  sub: string
  onClick: () => void
  disabled?: boolean
  destructive?: boolean
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={`w-full rounded-xl border px-3 py-3 text-left disabled:opacity-50 ${
        destructive
          ? "border-red-500/30 bg-red-500/10"
          : "border-white/10 bg-white/[0.04]"
      }`}
    >
      <div className={`text-sm font-extrabold ${destructive ? "text-red-300" : "text-white"}`}>
        {title}
      </div>
      <div className="text-xs text-white/45">{sub}</div>
    </button>
  )
}
